import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Card, Icon, Label, Segment, Form, Button } from "semantic-ui-react"
import EmployeeCardForm from "./EmployeeCardForm"
import { roleOptions } from "../config/permissions"
import bind from "bind-decorator"
import { getCurrentEmployee, getEmplInfo } from "../ducks/employees"
import { showMessage } from "../ducks/alerts"
import { connect } from "react-redux"
import firebase from "../config/firebaseConfig"
import { withTranslation } from "react-i18next"

@withTranslation()
@connect(null, (dispatch) => ({
  getCurrentEmployee: (data) => dispatch(getCurrentEmployee(data)),
  showMessage: (m, t) => dispatch(showMessage(m, t)),
  getEmplInfo: (iin) => dispatch(getEmplInfo(iin)),
}))
export default class EmployeeCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editedData: props.createEmployee
        ? {
            roles: [],
            stores: props.storeOptions ? [props.storeOptions[0].value] : [],
          }
        : false,
      step: 0,
      loading: false,
      icon: false,
    }
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onChange(e) {
    const { showMessage, t } = this.props
    this.setState({
      editedData: {
        ...this.state.editedData,
        [e.target.name]: e.target.value,
      },
    })
    if (e.target.name === "login") {
      if (e.target.value.slice(-1) !== "_") {
        this.props.getEmplInfo(e.target.value)
      }
    }
    if (e.target.name === "pass") {
      if (e.target.value.length === 6) {
        this.setState({
          loading: true,
        })
        window.confirmationResult
          .confirm(e.target.value)
          .then((result) => {
            this.setState({
              loading: false,
              icon: true,
            })
          })
          .catch(function(error) {
            showMessage(t("Enter the correct password code"), "error")
          })
      }
    }
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onRolesAndStoresChange({}, { value, name }) {
    this.setState({
      editedData: {
        ...this.state.editedData,
        [name]: value,
      },
    })
  }

  saveEmplData = (data) => {
    const employee = {
      id: data.id,
      firstName: data.firstName,
      lastName: data.lastName,
      login: data.login,
      middleName: data.middleName,
      owner: data.ownerId,
      roles: data.roles.map((role) => role.id),
      rolesOptions: roleOptions,
      stores: data.storeOptions.map((store) => store.value),
      storesForRender: data.stores,
      isOwner: data.isOwner,
    }
    this.props.getCurrentEmployee(employee)
  }

  @bind
  startEditing() {
    const {
      employeeId,
      firstName,
      lastName,
      middleName,
      login,
      roles,
      stores,
      phone,
    } = this.props
    this.setState({
      editedData: {
        employeeId,
        firstName,
        lastName,
        middleName,
        login,
        phone,
        roles: roles.map((r) => r.id),
        stores: stores.map((s) => s.id),
      },
    })
  }

  @bind
  cancelEditing() {
    this.setState({
      editedData: false,
      deleteClicked: false,
    })
  }

  @bind
  // eslint-disable-next-line no-empty-pattern
  onDelete({}, { data }) {
    const { deleteClicked } = this.state
    const { deleteEmployee } = this.props
    if (deleteClicked) {
      deleteEmployee(data)
      this.setState({
        deleteClicked: false,
      })
    }
    this.setState({
      deleteClicked: true,
    })
  }

  @bind
  onSave() {
    this.setState({
      step: 0,
    })
    const { editEmployee } = this.props
    const { editedData } = this.state
    editEmployee(editedData)
    this.cancelEditing()
  }

  @bind
  onCreate() {
    const { createEmployee, cancelCreating } = this.props
    const { editedData } = this.state
    createEmployee(editedData)
    cancelCreating()
  }

  @bind
  sendNumber() {
    const { showMessage, t } = this.props
    let appVerifier = window.recaptchaVerifier
    firebase
      .auth()
      .signInWithPhoneNumber(this.state.editedData.phone, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult
        this.setState({ step: 1 })
        // this.props.showMessage("Пароль отправлен на указанный номер", "success")
      })
      .then(() =>
        showMessage(t("Password sent to the specified number"), "success"),
      )
      /* eslint handle-callback-err: "error" */
      .catch((error) => showMessage(error.message, "error"))
  }

  renderEditingData() {
    const {
      editedData: {
        firstName,
        lastName,
        middleName,
        login,
        roles,
        stores,
        pass,
        pass2,
        phone,
      },
      deleteClicked,
    } = this.state
    const {
      employeeId,
      storeOptions,
      createEmployee,
      cancelCreating,
      t,
    } = this.props
    return [
      <Card.Content key="1">
        <Form>
          <Form.Input
            label={t("UIN")}
            type="text"
            name="login"
            value={login || ""}
            onChange={this.onChange}
          />
          {/* <Form.Input
            label="Пароль"
            type="password"
            name="pass"
            value={pass || ""}
            onChange={this.onChange}
          /> */}
          <Form.Input
            label={t("lastname")}
            type="text"
            name="lastName"
            value={lastName || ""}
            onChange={this.onChange}
          />
          <Form.Input
            label={t("firstname")}
            type="text"
            name="firstName"
            value={firstName || ""}
            onChange={this.onChange}
          />
          <Form.Input
            label={t("middlename")}
            type="text"
            id="mdl"
            name="middleName"
            value={middleName || ""}
            onChange={this.onChange}
          />
          {createEmployee ? (
            <>
              <div style={{ width: "100%" }}>
                <Form.Input
                  label={t("phoneNumber")}
                  type="text"
                  name="phone"
                  style={{ width: "70%" }}
                  value={phone || ""}
                  onChange={(e) => {
                    this.onChange(e)
                  }}
                />
                <Button
                  style={{ width: "25%", float: "right" }}
                  color="red"
                  content={t("Submit Code")}
                  id="captcha"
                />
              </div>
              <Form.Input
                label="Пароль"
                type="password"
                name="pass"
                value={pass || ""}
                onChange={this.onChange}
              />
              {/* <Form.Input
                label="Подтвердить пароль"
                type="password"
                name="pass2"
                value={pass2 || ""}
                onChange={this.onChange}
                error={pass !== pass2}
              /> */}
            </>
          ) : (
            <Form.Input
              label={t("phoneNumber")}
              type="text"
              name="phone"
              value={phone || ""}
              onChange={this.onChange}
            />
          )}
          <Form.Select
            options={roleOptions}
            multiple
            label={t("roles")}
            name="roles"
            value={roles}
            onChange={this.onChange}
          />
          <Form.Select
            options={storeOptions}
            multiple
            label={t("roles")}
            name="stores"
            value={stores}
            onChange={this.onChange}
          />
        </Form>
      </Card.Content>,
      createEmployee ? (
        <Card.Content key="2" extra>
          <Button
            color="green"
            onClick={this.onCreate}
            disabled={pass !== pass2}
          >
            {t("create")}
          </Button>
          <Button basic onClick={cancelCreating}>
            {t("cancel")}
          </Button>
        </Card.Content>
      ) : (
        <Card.Content key="2" extra>
          <Button color="green" onClick={this.onSave}>
            {t("save")}
          </Button>
          <Button basic onClick={this.cancelEditing}>
            {t("cancel")}
          </Button>
          <Button
            basic={!deleteClicked}
            color="red"
            data={employeeId}
            floated="right"
            onClick={this.onDelete}
          >
            {deleteClicked ? t("confirmDelete") : t("cancel")}
          </Button>
        </Card.Content>
      ),
    ]
  }

  renderData() {
    const {
      id,
      firstName,
      lastName,
      middleName,
      login,
      isOwner,
      roles,
      stores,
      t,
    } = this.props
    return (
      <Card.Content
        style={isOwner && { backgroundColor: "rgba(33, 186, 69, 0.1)" }}
      >
        <Card.Header>
          {isOwner ? login + " - владелец" : login + " - кассир"}
          {!isOwner && (
            <Label attached="top right" as="a" onClick={this.startEditing}>
              <Icon name="pencil" fitted /> {t("change").toLowerCase()}
            </Label>
          )}
          <Link to={"/employee/" + id}>
            <Label
              onClick={() => this.saveEmplData(this.props)}
              attached="bottom right"
              as="a"
              color="green"
            >
              <Icon name="address card" fitted /> профиль
            </Label>
          </Link>
        </Card.Header>
        <p>{lastName}</p>
        <p>{firstName}</p>
        <p>{middleName}</p>
        <p>
          <strong>{t("roles")}:</strong> {roles.map((r) => r.name).join(", ")}
        </p>
        <p>
          <strong>{t("stores")}:</strong> {stores.map((s) => s.name).join(", ")}
        </p>
      </Card.Content>
    )
  }

  render() {
    const { editedData } = this.state
    const { isLoading } = this.props
    return (
      <Card fluid as={Segment} loading={isLoading}>
        {editedData ? (
          <EmployeeCardForm
            {...this.state}
            onChange={this.onChange}
            onRolesAndStoresChange={this.onRolesAndStoresChange}
            onCreate={this.onCreate}
            onSave={this.onSave}
            onDelete={this.onDelete}
            employeeId={this.props.employeeId}
            roleOptions={roleOptions}
            storeOptions={this.props.storeOptions}
            createEmployee={this.props.createEmployee}
            cancelCreating={this.props.cancelCreating}
            cancelEditing={this.cancelEditing}
            sendNumber={this.sendNumber}
          />
        ) : (
          this.renderData()
        )}
      </Card>
    )
  }
}

EmployeeCard.propTypes = {
  employeeId: PropTypes.number,
  firstName: PropTypes.string,
  middleName: PropTypes.string,
  lastName: PropTypes.string,
  login: PropTypes.string,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  storeOptions: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  deleteEmployee: PropTypes.func,
  editEmployee: PropTypes.func,
  createEmployee: PropTypes.func,
  cancelCreating: PropTypes.func,
}
